import { requestTemplate } from 'api';
import { AxiosProgressEvent, CancelToken } from 'axios';
import { IDetails, IDocument, IFolder, IGroup, IRecycleBinFolder } from 'interfaces';

type DeleteResponce = {
  success: boolean,
  message: string,
}

//FOLDERS
const getFolders = (
  idRoom: string, sourceToken?: CancelToken
) => requestTemplate.get<IFolder[]>(`/folders/?room_id=${idRoom}`, {
  // params: payload,
  cancelToken: sourceToken,
});

const searchFolders = (
  idRoom: string, search: string, sourceToken?: CancelToken
) => requestTemplate.get<IFolder[]>(`/folders/?room_id=${idRoom}&search=${search}`, {
  cancelToken: sourceToken,
});

const getFolderOfFolder = (folder_id: string, room_id: string) =>
  requestTemplate.get<IFolder>(`/folders/by_id/?room_id=${room_id}&folder_id=${folder_id}`);

const getFoldersOfFolder = (
  idFolder: string, sourceToken?: CancelToken
) => requestTemplate.get<IFolder[]>(`/folders/?folder_id=${idFolder}`, {
  cancelToken: sourceToken,
});

const uploadFolder = (
  payload: { formData: FormData, name: string, action: string, signal?: AbortSignal, onUploadProgress?: (progressEvent: AxiosProgressEvent) => void },
) => requestTemplate.post<IDocument>(`/documents/bulk_create_folder/?document_name=${payload.name}`, payload.formData,
  { 
    headers: { 'Content-type': 'multipart/form-data' },
    signal: payload.signal,
    onUploadProgress: payload.onUploadProgress
  },
);

const getFoldersPermissions = (
  payload: { room_id: string, group_id?: string },
) => requestTemplate.get<IFolder[]>(`/folders/permissions/`, { params: payload });

const getRolesPermissions = (
  payload: { room_id: string, folder_id?: string | null },
) => requestTemplate.get<IGroup[]>(`/folders/permissions/all/`, { params: payload });

const createFolder = (
  payload: { name: string, room: string, folder_id: string | null, details: IDetails },
) => requestTemplate.post<IFolder>(`/folders/?action=create&id=${payload.room}`, payload);

const addDocumentsToFolder = (
  payload: {document_ids: string[], folder_id: string | null, room_id: string },
) => requestTemplate.post<{ message: string }>('/folders/documents/', payload);

const setFolderPermission = (
  payload: { permission_types: string[], folder_id: string, room_id: string, group_id: string, details: IDetails },
) => requestTemplate.post<{ message: string }>(`/folders/permissions/?action=update&id=${payload.room_id}`, payload);

const deleteFolder = (folder_id: string) => requestTemplate.delete<DeleteResponce>(`/folders/?folder_id=${folder_id}`);

const getRecycleBinFolders = (room_id: string) =>
  requestTemplate.get<IRecycleBinFolder[]>('/recycle_bin/folders/', { params: { room_id } });

const deleteRecycleBinFolders = (payload: { room_id: string; folders_ids: string[]; is_bulk: boolean }) =>
  requestTemplate.delete<DeleteResponce>('/recycle_bin/folders/', { data: payload });

const restoreRecycleBinFolders = (payload: { room_id: string; folders_ids: string[] }) =>
  requestTemplate.post<DeleteResponce>('/recycle_bin/folders/restore/', payload);

const restoreRecycleBinFoldersInRoot = (payload: { room_id: string; folders_ids: string[] }) =>
  requestTemplate.post<DeleteResponce>('/recycle_bin/folders/restore-in-root/', payload);

const renameFolder = (folder_id: string, payload: { name: string }) =>
  requestTemplate.put<DeleteResponce>(`/folders/?folder_id=${folder_id}`, payload);

const moveFolders = (payload: { room_id: string; folder_ids: string[]; target_folder_id: string | null }) =>
  requestTemplate.post<{ message: string }>('/folders/move/', payload);

const renameDocument = (payload: { name: string, id: string }) =>
  requestTemplate.put<DeleteResponce>(`/documents/`, payload);

const folders = {
  getFolders,
  searchFolders,
  uploadFolder,
  getFoldersOfFolder,
  getFoldersPermissions,
  getRolesPermissions,
  createFolder,
  addDocumentsToFolder,
  moveFolders,
  setFolderPermission,
  deleteFolder,
  renameFolder,
  getFolderOfFolder,
  renameDocument,
  deleteRecycleBinFolders,
  getRecycleBinFolders,
  restoreRecycleBinFolders,
  restoreRecycleBinFoldersInRoot,
};

export default folders;
